// The date after which new users stop seeing extra design options on My Appearance page
// Should be changed additionally to enable FLAG_HIDE_DESIGN_OPTIONS feature flag
export const DATE_OF_HIDDEN_DESIGN_OPTIONS = '2030-10-23'
